import axios from "axios";

import { Toastr } from "clearsense-ui/components";

import { showToastrError } from "./common";

// const token = document.querySelector("[name=csrf-token]").content;

axios.defaults.headers = {
  "Content-Type": "application/json",
  common: {
    "X-CSRF-TOKEN": localStorage.getItem("token"),
  },
};

export const successHandler = response => {
  if (response.status === 200) {
    response.success = true;
  }

  if (response.data.notice) {
    Toastr.success(response.data.notice);
  }

  if (response.data?.error) {
    Toastr.error(response.data?.error);
  }

  return response;
};

export const errorHandler = error => {
  const axiosErrorMessage = error?.response?.data?.message?.split(".")[0];
  if (500 === error?.response?.status) {
    Toastr.error("Internal Server Error");
  } else showToastrError(axiosErrorMessage || error.response?.data);

  if (401 === error?.response?.status) {
    const requestURL = error?.config?.url;
    const requestPath = requestURL && new URL(requestURL)?.pathname;

    // Redirect to login route
    if (window.location.pathname !== "/login" && requestPath !== "/api/v1/users/get_current_user") {
      setTimeout(() => (window.location.href = "/login"), 2500);
    }

    return Promise.reject(error);
  }

  return Promise.reject(error && error.response);
};

export const setAxiosIntercepts = () => {
  axios.defaults.baseURL = process.env.BASE_URL;
  axios.defaults.headers = {
    "Content-Type": "application/json",
    credentials: "include",
  };
  axios.defaults.withCredentials = true;  
  axios.interceptors.response.use(successHandler, errorHandler);
};
